<div class="hch-stepper">
  <button (click)="decrease()">
    <img src="assets/icons/minus.svg" alt="" />
  </button>
  <h6>{{ selectedOption ? selectedOption.label : 'Any' }}</h6>
  <button (click)="increase()">
    <img src="assets/icons/plus.svg" alt="" />
  </button>
</div>
